import Rest from '@services/Rest'

/**
 * @typedef {DetailService}
 */
export default class DetailService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/product/details'
}
